import React from 'react'
import ReactDom from 'react-dom'
import { useFireStore } from '../../firebase/firebase'

import { Close } from 'components/misc/Icons'

export default function Modal({ open, onClose, id }) {

    const deletePost = async (id) => {
        try {
             return await useFireStore
            .collection('posts')
            .doc(`${id}`)
            .delete();
        }
        catch {
            console.log('error deleting post')
        }
        finally {
            console.log('post deleted')
        }
    }

    if (!open) return null

    return ReactDom.createPortal(
        <>
            <div className="fixed top-0 bottom-0 left-0 right-0 z-1100 bg-bglight dark:bg-bgdark opacity-70"/>
            <div className="fixed flex flex-col p-4 space-y-4 rounded z-1100 bg-itemlight dark:bg-itemdark w-144" style={{top: '50%',left: '50%',transform: 'translate(-50%, -50%)'}}>
                <div className="flex flex-row items-center justify-between h-10">
                    <div>
                        <h2 className="text-lg font-bold text-textlight dark:text-textdark">Please confirm</h2>
                    </div>
                    <div>
                        <button onClick={onClose} className="flex items-center justify-center w-8 h-8 rounded-full bg-lightfeature dark:bg-darkfeature dark:text-darktext hover:bg-gray-300 focus:outline-none">
                            <Close/>
                        </button>
                    </div>
                </div>
                <div>
                    <p className="text-textlight dark:text-textdark">Deleting this post will remove it permanently from your feed. It will not be recoverable. Are you sure you want to do this?</p>
                </div>
                <div className="flex items-center justify-end space-x-2">
                    <button
                        onClick={onClose}
                        className="px-3 py-2 text-sm rounded text-lighthighlight hover:bg-lightfeature">
                        Cancel
                    </button>
                    <button
                        onClick={() => deletePost(id)}
                        className="px-3 py-2 text-sm text-white rounded bg-danger hover:bg-blue-600">
                        Delete
                    </button>

                </div>

            </div>
        </>,
        document.getElementById('portal')
    )
}